import { render } from "./AccessStatistics.vue?vue&type=template&id=0ba79fbc&scoped=true&ts=true"
import script from "./AccessStatistics.vue?vue&type=script&lang=ts"
export * from "./AccessStatistics.vue?vue&type=script&lang=ts"

import "./AccessStatistics.vue?vue&type=style&index=0&id=0ba79fbc&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba79fbc"]])

export default __exports__